import type { HttpClient } from '@angular/common/http';
import type { Area } from '@thevillages/schemas';

import type { AvailableAreaParamsType } from '../available-areas';

import { Environment } from '../../../../environments/environment';
import { AddQueryParams } from '../../../utils/add-query-params';
import { GetRequest } from '../../../utils/get-request';

export async function AreasLoader(
  http: HttpClient,
  params: AvailableAreaParamsType,
): Promise<Area[]> {
  const _base = `${Environment.mapUrl}/areas`;
  const _url = params.id ? `${_base}/${params.id}` : AddQueryParams(_base, params);

  return GetRequest<Area[]>(http, _url, { priority: 'low' });
}
